import React from "react";

export const interactLiveResourcesExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '第三方用户ID',
    field: 'userId',
    width: 25,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '第三方使用邮箱',
    field: 'userEmail',
    width: 40,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '姓氏',
    field: 'firstName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '名',
    field: 'lastName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '用户编码',
    field: 'userCode',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '用户付费类型',
    field: 'userTypeStr',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '帐户使用类型',
    field: 'typeStr',
    width: 18,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '状态',
    field: 'statusStr',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '资源密码',
    field: 'password',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '到期时间',
    field: 'expirationTimeStr',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  }
];


export const resourcesLiveExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '直播名称',
    field: 'name',
    width: 25,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '开播时间',
    field: 'startDate',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '结束时间',
    field: 'endDate',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '直播类型',
    field: '_liveType',
    width: 10,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '观看类型',
    field: '_watchType',
    width: 10,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '直播分类',
    field: 'categoryName',
    width: 10,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '直播受众',
    field: 'scope',
    width: 30,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left', wrapText: true  },
    },
  },
  {
    headerName: '直播状态',
    field: '_state',
    width: 10,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  }
];



export const liveRecordDetailExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '参训姓名',
    field: 'name',
    width: 25,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '参训邮箱',
    field: 'userEmail',
    width: 50,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '进入时间',
    field: 'joinTime',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '离开时间',
    field: 'leaveTime',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  },
  {
    headerName: '持续时长（秒）',
    field: 'duration',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: { vertical: 'bottom', horizontal: 'left' },
    },
  }
];
